import React, { Component } from 'react';
import '../CSS/StudentHome.css';
import RecordList from './RecordList';
import Sidemenu from './Navbar/Sidemenu';


class StudentHome extends Component {
    //state = { user:''}
    constructor(props) {
        super(props);
        this.state = {user: ''};
    }
    componentDidMount = async () => {
        var user = localStorage.getItem("user");
        user = JSON.parse(user);
        if(user){
            this.setState({user:  user});
            console.log(this.state.user)
        }
    }
    render() {
        return(
            <div>
            <nav className="nav-wrapper grey darken-4 navbar">
            <div className="container">
            <a href="/" className="brand-logo">
                        <img
                            className="header__logo"
                            src="./logo.jpg"
                            alt="logo"
                            />
                            </a>
               <ul className = "right">
                   <li active><a href = "/sender">Home</a></li>
                   {/* <li active><a href = "javascript:void(0)">Electronics record
                   <ul>
                       <li><a href = "/sender">Sender</a></li>
                       <li active><a href = "/recipient">Recipient</a></li>
                        <li><a href = "/newRecord">Request Record</a></li>
                   </ul>
                   </a>
                   </li> */}
                    {this.state.user !='' && this.state.user.user_type =='0' &&
                    <>
                   <li><a href = "/sender">Sender</a></li>
                    <li active><a href = "/recipient">Recipient</a></li>
                    <li><a href = "/newRecord">Request Record</a></li>
                   <li active><a href = "/token">Token</a></li>
                   <li active><a href = "/coin">Coin</a></li>
                   <li active><a href = "/nft">NFT</a></li>
                   </>
                    }
                    {this.state.user !='' && this.state.user.user_type =='1' &&
                    <>
                   <li><a href = "/create-company">Company master</a></li>
                    <li active><a href = "/company-list">Company list</a></li>
                   </>
                    }
                   
                   <li><a href = "/">Log out</a></li>
               </ul>
            </div>

        </nav>
        
            <div className = "container-fluid bg-black">
                <div className="row">
                    <Sidemenu />
                    <div className="col s10">
                        <h4>List of records</h4>
                        <div className="card blue darken-3 headers">
                            <div className="row ">
                                <div className="col s3 white-text  ">
                                    <h6>Institute ID</h6>
                                </div>
                                <div className="col s3 white-text ">
                                    <h6>Record Name</h6>
                                </div>

                                <div className="col s3 white-text ">
                                    <h6>Description</h6>
                                </div>
                                <div className="col s3 white-text ">
                                    <h6>Created Timestamp</h6>
                                </div>
                            </div>
                        </div>
                        <RecordList/>
                    </div>
                </div>
            </div>
            </div>
        )
    }
}

export default StudentHome;
